import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Icon, Typography } from '@material-ui/core';

const Header = ({ showBackButton, title, onBackPress }) => (
  <Grid
    container
    direction="row"
    style={{ justifyContent: 'flex-start', paddingBottom: 5, borderBottomColor: 'black', borderBottom: 'solid', borderBottomWidth: 2 }}
  >
    {
      showBackButton && (
        <Typography variant="h1" className="d-flex align-items-center">
          <button
            type="button"
            style={{ border: 'none', backgroundColor: 'transparent' }}
            onClick={() => onBackPress()}
          >
            <Icon className="back">arrow_back</Icon>
          </button>
        </Typography>
      )
    }

    <Grid xs={showBackButton ? 10 : 12} container direction="column" style={{ paddingBottom: 5, alignItems: showBackButton ? 'flex-start' : 'flex-start', justifyContent: 'flex-start' }}>
      <Typography variant="h5">
        <Box fontWeight="fontWeightBold">
          {title}
        </Box>
      </Typography>
    </Grid>
  </Grid>
);

export default Header;
